import http from "../http-common-2";

class BookingDataService {
  getBookings(
    page: number,
    pageSize: number,
    dateType: string,
    search: string,
    bookingType: string,
    bookingStatus: string,
    preBookingStatus: string,
    dateTypevalue: string,
    dateValue: string,
    corporate: string,
    token: any
  ) {
    return http.get(
      `/bookings?pageSize=${pageSize}&page=${page}&dateType=${dateType}&search=${search}&bookingType=${bookingType}&bookingStatus=${bookingStatus}&filterDateType=${dateTypevalue}&filterDate=${dateValue}&preBookingStatus=${preBookingStatus}&corporate=${corporate}`,
      {
        headers: {
          authorization: `Bearer ${token}`,
        },
      }
    );
  }

  getAppSingleBookings(
    page: number,
    pageSize: number,
    dateType: string,
    search: string,
    bookingType: string,
    bookingStatus: string,
    preBookingStatus: string,
    dateTypevalue: string,
    dateValue: string,
    corporate: string,
    token: any
  ) {
    return http.get(
      `/bookings/single?pageSize=${pageSize}&page=${page}&dateType=${dateType}&search=${search}&bookingType=${bookingType}&bookingStatus=${bookingStatus}&filterDateType=${dateTypevalue}&filterDate=${dateValue}&preBookingStatus=${preBookingStatus}&corporate=${corporate}`,
      {
        headers: {
          authorization: `Bearer ${token}`,
        },
      }
    );
  }

  getSingleBooking(id: any) {
    return http.get(`/bookings/${id}`);
  }

  getSubscriptionDetails(token: any) {
    return http.get(`/subscriptions`, {
      headers: {
        authorization: `Bearer ${token}`,
      },
    });
  }

  getCorporatesDetails(token: any) {
    return http.get(`/corporates/dashboard/data`, {
      headers: {
        authorization: `Bearer ${token}`,
      },
    });
  }

  updateCorporatesDetails(id: string, token: any, data: any) {
    return http.patch(`/corporates/${id}`, data, {
      headers: {
        authorization: `Bearer ${token}`,
      },
    });
  }

  getAssessmentnDetails(token: any) {
    return http.get(`/assessments/dashboard/data`, {
      headers: {
        authorization: `Bearer ${token}`,
      },
    });
  }
  createBooking(data: any) {
    return http.post(`/bookings`, data, {
      headers: {
        "ms-app-version": "1.0.39",
      },
    });
  }
  createProvisionalBooking(data: any) {
    return http.post(`/non-app-booking`, data, {
      headers: {
        "ms-app-version": "1.0.39",
      },
    });
  }

  rescheduleBooking(data: any, id: any) {
    return http.patch(`/bookings/${id}`, data);
  }

  updateBooking(data: any, id: any) {
    return http.put(`/bookings/${id}`, data);
  }

  deleteBooking(id: any) {
    return http.delete(`/bookings/${id}`);
  }

  cancelBooking(id: any) {
    return http.delete(`/bookings/${id}/cancel`);
  }

  updatePreBookingStatus(id: any, status: any) {
    return http.post(`/bookings/${id}/set-pre-session-status?status=${status}`);
  }

  updateConfirmBooking(id: any) {
    return http.get(`/confirmbooking/${id}?paymentid=ORCA_PORTAL_${id}`);
  }

  updateInstantExpert(id: any, accept: any, expertId: any) {
    return http.get(
      `/bookings/${id}/status?accept=${accept}&expertId=${expertId}`
    );
  }
  getPaymentDetails(
    fromDate: any,
    toDate: any,
    page: any,
    pageSize: any,
    status: any,
    token: any
  ) {
    const fromParam = fromDate ? `from=${fromDate}` : "";
    const toParam = toDate ? `to=${toDate}` : "";

    const queryParams = [
      fromParam,
      toParam,
      `pageSize=${pageSize}`,
      `pageNo=${page}`,
      `status=${status}`,
    ]
      .filter((param) => param)
      .join("&");

    return http.get(`/razorpay/payments?${queryParams}`, {
      headers: {
        authorization: `Bearer ${token}`,
      },
    });
  }
  downloadPaymentDetails(fromDate: any, toDate: any) {
    return http.get(
      `/razorpay/payments/download?from=${fromDate}&to=${toDate}`,
      {
        responseType: "blob",
      }
    );
  }

  downloadUsersSymptoms(issues: any, from: any, to: any) {
    return http.post(
      `/users-symptoms-mapping/download`,
      { issues, from, to },
      {
        responseType: "blob",
      }
    );
  }

  downloadExpertBiling(fromDate: any, toDate: any, expert: any) {
    return http.get(
      `/expert-biling-sheet/download?from=${fromDate}&to=${toDate}&expert=${expert}`,
      {
        responseType: "blob",
      }
    );
  }

  downloadExpertsMonthlyBiling(month: any, year: any) {
    return http.get(
      `/bookings/experts/billing/download?month=${month}&year=${year}`,
      {
        responseType: "blob",
      }
    );
  }

  updateExpertPrice(id: any, price: any) {
    return http.patch(`/razorpay/payments/${id}?price=${price}`);
  }

  updateExpertId(id: any, expertId: any) {
    return http.patch(`/razorpay/payments/${id}/expert?expertId=${expertId}`);
  }

  syncPayments() {
    return http.get(`/razorpay/payments/sync`);
  }

  sendWhatsappNotification(data: any) {
    return http.post(`/send/whatsapp/notification`, data);
  }

  getExpertBilingData(page: any, pageSize: any, token: any, expert: any) {
    return http.get(
      `/expert-biling-sheet?pageSize=${pageSize}&page=${page}&expert=${expert}`,
      {
        headers: {
          authorization: `Bearer ${token}`,
        },
      }
    );
  }

  updateExpertBilingData(id: any, data: any) {
    return http.patch(`/non-app-booking/${id}/update`, data);
  }

  getNonAppBookings(page: any, pageSize: any, token: any, search: any) {
    return http.get(
      `/non-app-booking?pageSize=${pageSize}&page=${page}&search=${search}`,
      {
        headers: {
          authorization: `Bearer ${token}`,
        },
      }
    );
  }

  getBookingMonthlyData(type: any) {
    return http.get(`bookings/count/monthlydata?type=${type}`);
  }

  getSingleBookingDetails(
    page: any,
    pageSize: any,
    search: any,
    sessionCount: any,
    sortingType: any
  ) {
    return http.get(
      `single-booking-details?page=${page}&pageSize=${pageSize}&search=${search}&count=${sessionCount}&sorting=${sortingType}`
    );
  }

  getSIFFData() {
    return http.get(`SIFF/bookings`);
  }

  approvedBooking(id: string, status: string) {
    return http.patch(`bookings/${id}/approved?status=${status}`);
  }

  expertWeeklyBookings(id: string, dates: any) {
    return http.get(`expert/weeklybookings?expertId=${id}&dates=${dates}`);
  }

  getModifiedBookings(
    page: number,
    pageSize: number,
    dateType: string,
    search: string,
    bookingType: string,
    bookingStatus: string,
    preBookingStatus: string,
    dateTypevalue: string,
    dateValue: string,
    corporate: string,
    token: any
  ) {
    return http.get(
      `/bookings?pageSize=${pageSize}&page=${page}&dateType=${dateType}&search=${search}&bookingType=${bookingType}&bookingStatus=${bookingStatus}&filterDateType=${dateTypevalue}&filterDate=${dateValue}&preBookingStatus=${preBookingStatus}&corporate=${corporate}&filterModifiedBookings=true`,
      {
        headers: {
          authorization: `Bearer ${token}`,
        },
      }
    );
  }

  syncWixProvisionalBookings(date: any) {
    return http.get(`wix/internal?date=${date}`);
  }
}
export default new BookingDataService();
